import { Button, Tooltip } from '~/components/granular';
import { classNames } from '~/utils/styles';

import type { ButtonActionsProps } from './ButtonActions.types';

export const ButtonActions = ({ actions, className }: ButtonActionsProps) => (
  <div className={classNames('flex items-center gap-2', className)} data-testid="button-actions">
    {actions.map((action) => {
      const button = (
        <Button
          appearance={action.appearance}
          disabled={action.disabled}
          form={action.form}
          key={action.id}
          leftIcon={action.leftIcon}
          loading={action.loading}
          onClick={action.onClick}
          rightIcon={action.rightIcon}
          size={action.size}
          type={action.type}
        >
          {action.label}
        </Button>
      );

      if (action.tooltip) {
        return (
          <Tooltip key={action.id} side="bottom" trigger={button} triggerDisabled={action.disabled}>
            {action.tooltip}
          </Tooltip>
        );
      }

      return button;
    })}
  </div>
);
